import script from "./StudentGoodMoralDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentGoodMoralDialog.vue?vue&type=script&setup=true&lang=js"

import "./StudentGoodMoralDialog.vue?vue&type=style&index=0&id=7c4e3181&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c4e3181"]])

export default __exports__